/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { Component } from "@angular/core";
import { JscdkWrapper } from "../../common/jscdk/jscdk-wrapper";
import { AbstractModalComponent } from "../../common/commondialog/abstract-modal.component";
import { LoginTypesKey } from "../../login/common/content-data";
import { LoginService } from "../../login/login-root/login.service";

const ReAuthKeys: Array<LoginTypesKey> = [
   "WindowsPassword",
   "SecurIDPasscode",
   "SecurIDNextTokenCode",
   "SecurIDPinChange",
   "SecurIDWait",
   "WindowsPasswordExpired"
];
@Component({
   standalone: false,
   selector: "reauth-dialog",
   templateUrl: "./reauth-dialog.component.html"
})
export class ReauthDialogComponent extends AbstractModalComponent {
   public contentData;

   constructor(
      jscdkWrapper: JscdkWrapper,
      private loginService: LoginService
   ) {
      super();
      this.loginService.reauthDialogRedraw$.subscribe((data) => {
         this.contentData = data;
      });
      if (ReAuthKeys.includes(jscdkWrapper.data.name)) {
         this.contentData = jscdkWrapper.data;
      }
   }
}
